module.exports = "https://cdn.thelire.com/ins/resource/no_folllowers_drop@3x.80d891fb712359cda69645daa91b5402.png";